export default "__VITE_ASSET__5abc9958__"